import axios from "axios";

import { extractors, tagList } from "@/utils";

axios.defaults.baseURL = process.env.VUE_APP_BACKEND_URL;

const state = () => ({
  activeMenu: {
    home: true,
    integrations: false,
    features: false,
    customers: false,
    contact: false,
  },
  listExtractors: extractors || [],
  filteredExtractors: extractors || [],
  listTags: tagList,
});

const getters = {
  getActiveMenu: (state) => state.activeMenu,
  getListExtractors: (state) => state.listExtractors,
  getFilteredExtractors: (state) => state.filteredExtractors,
  getListTags: (state) => state.listTags,
};

const actions = {
  setActiveMenu({ commit }, payload) {
    commit("updateActiveMenu", payload);
  },
  setTagFilter({ commit }, tag) {
    commit("filterTagList", tag);
  },
  sendContactMessage({ commit }, payload) {
    return axios
      .post("contact/", payload)
      .then(() => commit("contactSent", 201))
      .catch(() => commit("contactSent", 400));
  },
};

const mutations = {
  updateActiveMenu(state, payload) {
    const restoreMenuStatus = {
      home: false,
      integrations: false,
      features: false,
      customers: false,
      contact: false,
    };
    const newStatus = { ...restoreMenuStatus, [payload]: true };
    state.activeMenu = newStatus;
  },
  contactSent(state, payload) {
    console.log("Response", payload);
  },
  filterTagList(state, payload) {
    const auxTags = [...state.listTags];
    auxTags.map((tag) => {
      tag.isSelected = false;
      if (payload.name === tag.name) {
        tag.isSelected = true;
      }
    });

    state.listExtractors.map((tag) => {
      tag.isSelected = false;
    });

    if (payload.name !== "TODOS") {
      const auxExtractors = [...state.listExtractors];
      state.filteredExtractors = auxExtractors.filter(
        (tag) => tag.type === payload.name
      );
    } else {
      state.filteredExtractors = extractors;
    }
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
